import { useGetUserCredentials } from 'academy-common-lib/features/profile/data/accreditation';
import ProgressTransferContainer from 'academy-common-lib/features/certificate/components/progressTransfer/ProgressTransferContainer';
import UsageTracker from '../../../../utils/UsageTracker';
import ApiError from '../../../../components/Errors/ApiError';
import { useUserInfo } from '../../../accounts';
import { jsx as _jsx } from "react/jsx-runtime";
const ProgressTransferModal = ({
  isOpen,
  onClose
}) => {
  var _userInfo$user, _userCredentialsData$, _userInfo$user2;
  const {
    userInfo
  } = useUserInfo();
  const userId = userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.id;
  const {
    data: userCredentialsData
  } = useGetUserCredentials(userId);
  const userCertificateNames = (userCredentialsData === null || userCredentialsData === void 0 || (_userCredentialsData$ = userCredentialsData.credentials) === null || _userCredentialsData$ === void 0 ? void 0 : _userCredentialsData$.map(credential => credential.title)) || [];
  const handleTrackEvent = eventProps => {
    UsageTracker.track('teamInteraction', eventProps);
  };
  const currentUserEmail = (userInfo === null || userInfo === void 0 || (_userInfo$user2 = userInfo.user) === null || _userInfo$user2 === void 0 || (_userInfo$user2 = _userInfo$user2.emails) === null || _userInfo$user2 === void 0 ? void 0 : _userInfo$user2[0]) || '';
  return /*#__PURE__*/_jsx(ProgressTransferContainer, {
    ErrorComponent: ApiError,
    currentUserEmail: currentUserEmail,
    handleClose: onClose,
    isOpen: isOpen,
    trackEvent: eventProps => {
      if (eventProps) {
        handleTrackEvent(eventProps);
      }
    },
    userCredentials: userCertificateNames
  });
};
export default ProgressTransferModal;